var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3301 6.75391H16.7734V1.66992C16.7734 0.749127 16.0243 0 15.1035 0H1.66992C0.749127 0 0 0.749127 0 1.66992V11.7637C0 12.6845 0.749127 13.4336 1.66992 13.4336H5.77904L5.06855 14.8546C4.98227 15.0271 4.99147 15.2321 5.09289 15.3962C5.19431 15.5603 5.37351 15.6602 5.56641 15.6602H11.207H11.207V17.3301C11.207 18.2509 11.9562 19 12.877 19H17.3301C18.2509 19 19 18.2509 19 17.3301V8.42383C19 7.50303 18.2509 6.75391 17.3301 6.75391ZM6.46709 14.5469L7.02373 13.4336H9.74975L10.3063 14.5469H6.46709ZM11.207 13.8589L10.9944 13.4336H11.207V13.8589ZM11.207 12.3203H1.66992C1.36299 12.3203 1.11328 12.0706 1.11328 11.7637V11.207H11.207V12.3203ZM11.207 8.42383V10.0938H1.11328V1.66992C1.11328 1.36299 1.36299 1.11328 1.66992 1.11328H15.1035C15.4104 1.11328 15.6602 1.36299 15.6602 1.66992V6.75391H12.877C11.9562 6.75391 11.207 7.50303 11.207 8.42383ZM17.8867 17.3301C17.8867 17.637 17.637 17.8867 17.3301 17.8867H12.877C12.57 17.8867 12.3203 17.637 12.3203 17.3301V16.7734H17.8867V17.3301ZM17.8867 15.6602H12.3203V10.0938H17.8867V15.6602ZM17.8867 8.98047H12.3203V8.42383C12.3203 8.1169 12.57 7.86719 12.877 7.86719H17.3301C17.637 7.86719 17.8867 8.1169 17.8867 8.42383V8.98047Z",
    fill: "#0E142C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/devices-icon.0b900184e83acf1c4cf0259d28ee3362.svg";
export { ForwardRef as ReactComponent };